export default [
  {
    action: 'reopen',
    label: 'Reopen with comment',
  },
];
